import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@mui/material';
import { getApplicationStatus, getStatusList } from 'api/case-management';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ComputerIcon from '@mui/icons-material/Computer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { notification } from 'antd'; // Import notification component
import Collapse from '@mui/material/Collapse';
import '../landing/landing.css';
const useStyles = makeStyles((theme) => ({
  rootGeneral: {
    flexGrow: 1,
    margin: '1% 2%',
    [theme.breakpoints.down('md')]: {
      margin: '2% 1%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1% 0.5%',
    },
  },
  root: {
    flexGrow: 1,
    margin: '0 2%',
    padding: '0 3% 5% 3%',
    [theme.breakpoints.down('sm')]: {
      margin: '0 1%',
      padding: '0 2% 3% 2%',
    },
  },
  nav: {
    width: '100%',
  },
  fieldset: {
     border: '4px solid #26516F',
    borderRadius: '50px',
    margin: '10px 20px',
    [theme.breakpoints.down('md')]: {
      margin: '10px 15px',
      borderRadius: '30px',
      border: '3px solid #26516F',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '10px 5px',
      borderRadius: '20px',
      border: '2px solid #26516F',
    },
  },
  legend: {
    color: '#26516F',
    fontSize: '2em',
    fontWeight: '700',
    marginLeft: '30px',
    padding: '0 10px',
    maxWidth: '505px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5em',
      marginLeft: '15px',
      padding: '0 5px',
      maxWidth: '300px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
      marginLeft: '10px',
      maxWidth: '250px',
    },
  },
  article: {
    fontSize: '1.8em',
    fontWeight: '600',
    textDecoration: 'underline',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  }
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: theme.palette.grey[700], // Directly use theme properties
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
    [theme.breakpoints.down('sm')]: {
      top: 15,
    },
    [theme.breakpoints.down('xs')]: {
      top: 12,
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient(95deg, rgb(0,70,105) 0%, rgb(0,105,170) 50%, rgb(0,140,210) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient(95deg, rgb(0,70,105) 0%, rgb(0,105,170) 50%, rgb(0,140,210) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.grey[800], // Directly use theme properties
    borderRadius: 1,
    [theme.breakpoints.down('sm')]: {
      height: 2,
    },
    [theme.breakpoints.down('xs')]: {
      height: 1.5,
    },
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[700], // Directly use theme properties
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  textAlign: 'center',
  marginLeft: '5px',
  alignItems: 'center',
  cursor: 'pointer!important',
  [theme.breakpoints.down('sm')]: {
    width: 30,
    height: 30,
    '& svg': {
      fontSize: '1rem',
    },
  },
  [theme.breakpoints.down('xs')]: {
    width: 25,
    height: 25,
    '& svg': {
      fontSize: '0.875rem',
    },
  },
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundImage:
          'linear-gradient(136deg, rgb(0,70,105) 0%, rgb(0,105,170) 50%, rgb(0,140,210) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundImage:
          'linear-gradient(136deg, rgb(0,70,105) 0%, rgb(0,105,170) 50%, rgb(0,140,210) 100%)',
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, onClick } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <AssignmentTurnedInIcon />,
    3: <AssignmentIcon />,
    4: <ComputerIcon />,
    5: <CheckCircleIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className} onClick={onClick}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
  onClick: PropTypes.func
};

function ApplicationStatus() {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(max-width:960px)');

  const [referenceNumber, setReferenceNumber] = useState('');
  const [data, setData] = useState({});
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [expandedStep, setExpandedStep] = useState(null);
  const [activeStatus, setActiveStatus] = useState();
  const [activeSubStatus, setActiveSubStatus] = useState('');
  const [openTooltip, setOpenTooltip] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStepData, setSelectedStepData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const handleStepClick = (stepIndex) => {
    if (isMobile && steps[stepIndex]?.sub_status) {
      setSelectedStepData(steps[stepIndex]);
      setModalOpen(true);
    } else {
      setExpandedStep(expandedStep === stepIndex ? null : stepIndex);
    }
  };

  const handleTooltipClick = (stepIndex) => {
    if (isMobile) {
      setOpenTooltip(openTooltip === stepIndex ? null : stepIndex);
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedStepData(null);
  };

  // Close tooltip when clicking outside
  const handleOutsideClick = () => {
    if (isMobile && openTooltip !== null) {
      setOpenTooltip(null);
    }
  };

  const handleSearchApplicationStatus = async () => {
    if (!referenceNumber) {
      notification.error({
        message: 'Error',
        description: 'Please enter a reference number',
        duration: 4,
      });
      return;
    }

    setLoading(true);
    try {
      const res = await getApplicationStatus(referenceNumber);
      const data = res.data;
      setData(data);
      setActiveStatus(data.status.id);
      setActiveSubStatus(data.sub_status);

      // Update activeStep based on statusorder
      if (data.status?.statusorder) {
        let statusOrder = parseInt(data.status.statusorder, 0);
        setActiveStep(statusOrder);
        handleStepClick(statusOrder);
      }
    } catch (error) {
      console.error('Error fetching application status');
      notification.error({
        message: 'Error',
        description: 'Failed to retrieve application status. Please try again.',
        duration: 4,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusList = async () => {
    try {
      const res = await getStatusList();
      const data = res.data;

      // Sort the data by statusorder
      const sortedData = data.sort((a, b) => a.statusorder - b.statusorder);

      // Filter out the data with main_status other than [] or null
      const filteredData = sortedData.filter(
        (status) => status.main_status === null || status.main_status === "[]"
      );

      // Parse main_status as an array
      const subStatus = sortedData.filter((status) => {
        try {
          const mainStatusArray = JSON.parse(status.main_status || "[]");
          status.main_status = mainStatusArray;
          return mainStatusArray.length > 0;
        } catch (error) {
          console.error(`Invalid main_status JSON for status ${status.id}:`, error);
          status.main_status = [];
          return false;
        }
      });

      const mainStatus = filteredData.map((status) => {
        const matchedSubStatus = subStatus.filter((sub) => sub.main_status.includes(status.id));
        if (matchedSubStatus.length > 0) {
          return {
            ...status,
            sub_status: matchedSubStatus,
          };
        }

        return status;
      });

      setSteps(mainStatus);
      setData(filteredData);
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to load status options. Please refresh the page.',
        duration: 4,
      });
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    fetchStatusList();
  }, []); // Empty dependency array ensures this runs once on mount

  // Add click listener to handle outside clicks for tooltip
  useEffect(() => {
    if (isMobile) {
      document.addEventListener('click', handleOutsideClick);
      return () => {
        document.removeEventListener('click', handleOutsideClick);
      };
    }
  }, [isMobile, openTooltip]);

  return (
    <div className={classes.rootGeneral}>
      <div className={classes.nav}>
        <Grid item l={12} xs={12}>
          <fieldset className={classes.fieldset}>
            <legend className={classes.legend}>Kabahagi Application Status</legend>
            <div className={classes.root}>
              <div className={classes.nav}>
                <Box mb={2}>
                  <Typography 
                    fontWeight="bold"
                    sx={{
                      fontSize: isMobile ? '0.9rem' : '1rem',
                      textAlign: isMobile ? 'center' : 'left',
                    }}
                  >
                    Type in your Reference Number.
                  </Typography>
                </Box>
                <Box mb={2} display="flex" justifyContent="center">
                  <Paper
                    component="form"
                    sx={{ 
                      p: '2px 4px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      width: isMobile ? '95%' : isTablet ? 350 : 400,
                      maxWidth: '100%',
                    }}
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSearchApplicationStatus(referenceNumber);
                    }}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="Reference Number"
                      inputProps={{ 'aria-label': 'Reference Number' }}
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
                      onClick={handleSearchApplicationStatus}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={20} sx={{ color: '#26516F' }} />
                      ) : (
                        <SearchIcon />
                      )}
                    </IconButton>
                  </Paper>
                </Box>
                <Box className="serviceCard">
                  <Box className="serviceHead">
                    Application Status
                  </Box>
                  <Box mt={2}>
                    {initialLoading ? (
                      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                        <Box textAlign="center">
                          <CircularProgress 
                            size={40} 
                            sx={{ 
                              color: '#26516F',
                              mb: 2 
                            }} 
                          />
                          <Typography 
                            variant="body2" 
                            color="textSecondary"
                            sx={{ fontSize: isMobile ? '0.8rem' : '0.9rem' }}
                          >
                            Loading status options...
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Stack sx={{ width: '100%' }} alignContent={'center'} spacing={isMobile ? 2 : 4}>
                      <Stepper 
                        alternativeLabel={!isMobile}
                        orientation="horizontal"
                        activeStep={activeStep} 
                        connector={<ColorlibConnector />}
                        sx={{
                          '& .MuiStepLabel-label': {
                            fontSize: isMobile ? '0.7rem' : '0.875rem',
                            marginTop: isMobile ? '4px' : '8px',
                            display: isMobile ? 'none' : 'block',
                          },
                          '& .MuiStep-root': {
                            padding: isMobile ? '0 2px' : '0 8px',
                          }
                        }}
                      >
                        {steps.map((data, index) => (
                          <Step key={data.name}>
                            {isMobile ? (
                              <Tooltip 
                                title={data.name} 
                                arrow 
                                placement="top"
                                open={openTooltip === index}
                                disableHoverListener
                                disableFocusListener
                                disableTouchListener
                              >
                                <StepLabel StepIconComponent={(props) => (
                                  <ColorlibStepIcon 
                                    {...props} 
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent event bubbling
                                      handleStepClick(index);
                                      handleTooltipClick(index);
                                    }} 
                                  />
                                )}>
                                  {/* Empty label for mobile */}
                                </StepLabel>
                              </Tooltip>
                            ) : (
                              <StepLabel StepIconComponent={(props) => (
                                <ColorlibStepIcon {...props} onClick={() => handleStepClick(index)} />
                              )}>
                                {data.name}
                              </StepLabel>
                            )}
                            {!isMobile && (
                              <Collapse in={expandedStep === index} timeout="auto" unmountOnExit>
                                {data.sub_status && (
                                  <Box mt={.5}>
                                    {data.sub_status.map((subStatus) => (
                                      <Box
                                        mb={.5}
                                        key={subStatus.id}
                                        sx={{
                                          backgroundColor: data.id === activeStatus && subStatus.id === activeSubStatus ? '#1c5272' : '#616161',
                                          color: '#fff',
                                          padding: isMobile ? '6px' : '8px',
                                          borderRadius: '4px',
                                          margin: isMobile ? '0.25rem 0' : '0.5rem 0',
                                        }}
                                      >
                                        <Typography 
                                          variant={isMobile ? "caption" : "body2"} 
                                          style={{ 
                                            textAlign: 'center',
                                            fontSize: isMobile ? '0.75rem' : '0.875rem',
                                          }}
                                        >
                                          {subStatus.name}
                                        </Typography>
                                      </Box>
                                    ))}
                                  </Box>
                                )}
                              </Collapse>
                            )}
                          </Step>
                        ))}
                      </Stepper>
                    </Stack>
                    )}
                  </Box>
                  
                  {/* Modal for mobile sub-status display */}
                  <Modal
                    open={modalOpen}
                    onClose={handleModalClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={modalOpen}>
                      <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        maxWidth: 400,
                        bgcolor: 'background.paper',
                        borderRadius: '12px',
                        boxShadow: 24,
                        p: 3,
                        outline: 'none',
                      }}>
                        <Typography 
                          variant="h6" 
                          component="h2" 
                          sx={{ 
                            mb: 2, 
                            textAlign: 'center',
                            color: '#26516F',
                            fontWeight: 'bold'
                          }}
                        >
                          {selectedStepData?.name}
                        </Typography>
                        
                        {selectedStepData?.sub_status && (
                          <Box>
                            {selectedStepData.sub_status.map((subStatus) => (
                              <Box
                                key={subStatus.id}
                                sx={{
                                  backgroundColor: selectedStepData.id === activeStatus && subStatus.id === activeSubStatus ? '#1c5272' : '#616161',
                                  color: '#fff',
                                  padding: '12px',
                                  borderRadius: '8px',
                                  margin: '8px 0',
                                  textAlign: 'center',
                                }}
                              >
                                <Typography variant="body2">
                                  {subStatus.name}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
                        
                        <Box sx={{ mt: 3, textAlign: 'center' }}>
                          <IconButton 
                            onClick={handleModalClose}
                            sx={{
                              backgroundColor: '#26516F',
                              color: 'white',
                              '&:hover': {
                                backgroundColor: '#1c3d54',
                              },
                              padding: '8px 16px',
                              borderRadius: '20px',
                            }}
                          >
                            <Typography variant="body2">Close</Typography>
                          </IconButton>
                        </Box>
                      </Box>
                    </Fade>
                  </Modal>
                  
                  <Box className="serviceBody" p={isMobile ? 1 : 2}>
                    {loading ? (
                      <Box display="flex" justifyContent="center" alignItems="center" minHeight={100}>
                        <Box textAlign="center">
                          <CircularProgress 
                            size={30} 
                            sx={{ 
                              color: '#26516F',
                              mb: 1 
                            }} 
                          />
                          <Typography 
                            variant="body2" 
                            color="textSecondary"
                            sx={{ fontSize: isMobile ? '0.8rem' : '0.9rem' }}
                          >
                            Retrieving application status...
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Typography 
                          variant={isMobile ? "body2" : "body1"} 
                          fontWeight="bold" 
                          mb={isMobile ? 1 : 2}
                          sx={{ fontSize: isMobile ? '0.9rem' : '1rem' }}
                        >
                          Child's name: <span style={{ fontWeight: 'normal' }}>{data.child_name}</span>
                        </Typography>
                        <Typography 
                          variant={isMobile ? "body2" : "body1"} 
                          fontWeight="bold" 
                          mb={isMobile ? 1 : 2}
                          sx={{ fontSize: isMobile ? '0.9rem' : '1rem' }}
                        >
                          Parent's name: <span style={{ fontWeight: 'normal' }}>{data.parent_name}</span>
                        </Typography>
                        <Typography 
                          variant={isMobile ? "body2" : "body1"} 
                          fontWeight="bold" 
                          mb={isMobile ? 1 : 2}
                          sx={{ fontSize: isMobile ? '0.9rem' : '1rem' }}
                        >
                          Notes: <span style={{ fontWeight: 'normal' }}>{data.remarks}</span>
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
              </div>
            </div>
          </fieldset>
        </Grid>
      </div>
    </div>
  );
}

export default ApplicationStatus;